import { Vesting } from "@eave/shared/types/api/vesting";

import APIClient from "web_modules/APIClient";

export const createVesting = (id: number, vesting: Vesting) => {
  return APIClient.post(`/loan_applications/${id}/hurdles/vesting`, {
    vesting_type: vesting.type,
    vesting_to_read: vesting.toRead,
    marital_status: vesting.maritalStatus,
  });
};

export const upsertPowerOfAttorney = (appId: number, values: any) => {
  return APIClient.post(`/loan_applications/${appId}/hurdles/vesting/power_of_attorney`, {
    borrower_principal: values.borrower_principal,
    authorized_agent: values.authorized_agent,
    other_authorized_agent_name:
      values.authorized_agent !== "other" ? "" : values.other_authorized_agent_name,
  });
};

export const deletePowerOfAttorney = (appId: number, id: any) => {
  return APIClient.deleteRequest(
    `/loan_applications/${appId}/hurdles/vesting/power_of_attorney/${id}`,
  );
};
